<template>
	<ProjectAppointmentDetailSection
		:title="title"
		:open="open"
		@toggle-open="$emit('toggle-open')"
		:show-next-button="shouldShowNextButton()"
		class="section"
		v-if="questionGroup.constant !== 'QUALITY_SPOUWMUUR_KLANTTEVREDENHEID' || showKlanttevredenheid"
		@open-next="save(false)"
	>
		<div class="question-section">
			<div
				class="question"
				:class="{stacked: (question.childQuestions != null &&
        		question.childQuestions.length === 1) || question.type === 'FILE'}"
				v-for="([id, question], index) in questions"
				v-if="shouldShowQuestion(question)"
				:key="id"
			>
				<div
					class="stacked-inner" v-if="(question.childQuestions != null &&
        		question.childQuestions.length === 1) || question.type === 'FILE'"
				>

					<QuestionSingleFileUpload
						v-if="question.childQuestions != null &&
        		question.childQuestions.length === 1"
						v-model="answers.get(question.childQuestions[0].id).value"
						:title="question.childQuestions[0].name"
						:type="question.childQuestions[0].config.type"
						:companyId="companyId"
						:disabled="disabled"
						ref="fileUpload"
					></QuestionSingleFileUpload>
					<div class="errors">
            <span
				class="child-question-error" v-if="question.childQuestions != null &&
						  question.childQuestions.length > 0 && errors.has(question.childQuestions[0].id)"
			>{{ errors.get(question.childQuestions[0].id) }}
            </span>
					</div>
					<input
						v-if="question.type === 'NUMBER'"
						type="number"
						:placeholder="question.config.placeholder"
						:id="id"
						:disabled="disabled"
						v-model="answers.get(id).value"
					/>
					<QuestionSingleFileUpload
						v-if="question.type === 'FILE'"
						v-model="answers.get(id).value"
						:title="question.name"
						:type="question.config.type"
						:companyId="companyId"
						:disabled="disabled"
						:show-uploaded-time="question.config.hasOwnProperty('saveTimestamp') && question.config.saveTimestamp === true"
						ref="fileUpload"
					></QuestionSingleFileUpload>
					<div class="errors">
						<span v-if="errors.has(question.id)" class="form-error">{{ errors.get(question.id) }}</span>
					</div>
				</div>
				<div v-else class="question-inner" :class="question.type === 'RADIO-VERTICAL' || question.type === 'RADIO-SUPPORT_TICKET' ? 'vertical' : ''">
					<label
						v-if="['SIGNATURE', 'TEXT', 'RADIO-KMK', 'FILE'].includes(question.type) === false && (question.config.hasOwnProperty('labelHidden') === false || question.config.hasOwnProperty('labelHidden')  === true && question.config.labelHidden === false)  " :for="id"
					>{{
							question.name
						}}
					</label>
					<input
						v-if="question.type === 'NUMBER'"
						type="number"
						:placeholder="question.config.placeholder"
						:id="id"
						:disabled="disabled"
						v-model="answers.get(id).value"
						:class=" question.config.hasOwnProperty('labelHidden')  === true && question.config.labelHidden === true ? 'no-label' : ''"
					/>
					<QuestionEmailInput
						v-if="question.type === 'EMAIL'"
						type="email"
						:config="question.config"
						:variables="variables"
						:id="id"
						:disabled="disabled"
						v-model="answers.get(id).value"
					/>
					<textarea
						v-if="question.type === 'TEXT'"
						:placeholder="question.config.placeholder"
						:id="id"
						:disabled="disabled"
						v-model="answers.get(id).text_value"
						rows="5"
					>
                    </textarea>
					<select
						v-if="question.type === 'SELECT'" :id="id" v-model="answers.get(id).value" :disabled="disabled"

					>
						<option disabled :value="null">{{ question.config.placeholder }}</option>
						<option
							v-for="option in question.config.options" :key="option" :value="option"
						>{{ option }}
						</option>
					</select>
					<QuestionDynamicSelect
						v-if="question.type === 'DYNAMIC-SELECT'"
						:id="id"
						:config="question.config"
						:variables="variables"
						:disabled="disabled"
						v-model="answers.get(id).value"
					></QuestionDynamicSelect>
					<QuestionFileUpload
						v-if="question.type === 'FOLDER'"
						v-model="answers.get(id).value"
						:title="question.config.placeholder"
						:type="question.config.type"
						:companyId="companyId"
						:multiple="true"
						:disabled="disabled"
						ref="fileUpload"
					></QuestionFileUpload>
					<QuestionKmkInput
						v-if="question.type === 'RADIO-KMK'"
						:answer="answers.get(id)"
						:question="question"
						:disabled="disabled"
						:config="question.config"
					/>
					<div v-if="question.type === 'RADIO'" class="radio-options">
						<div v-for="(option, index2) in question.config.options" class="option">
							<input
								:id="index + '.' + index2"
								type="radio"
								:value="option"
								v-model="answers.get(id).value"
								:disabled="disabled"
								:name="index"
							>
							<label :for="index + '.' + index2">{{ option }}</label>
						</div>
					</div>
					<div v-if="question.type === 'RADIO-VERTICAL' || question.type === 'RADIO-SUPPORT_TICKET'" class="radio-options vertical" >
						<div v-for="(option, index2) in question.config.options" class="option">
							<input
								:id="index + '.' + index2"
								type="radio"
								:value="option"
								v-model="answers.get(id).value"
								:disabled="disabled"
								:name="index"
								@click="forceChange(); question.type === 'RADIO-SUPPORT_TICKET' ? setQualityShowKlanttevredenheid( option === 'Nee') : ''"
							>
							<label :for="index + '.' + index2">{{ option }}</label>
						</div>
					</div>
					<QualitySupportTicketSection
						v-if="question.type === 'RADIO-SUPPORT_TICKET' && answers.get(id).value === 'Ja'"
						:appointment-id="appointmentId"
						:company-id="companyId"
						:project-id="projectId"
					></QualitySupportTicketSection>
					<QuestionSignatureInput
						v-if="question.type === 'SIGNATURE'"
						:company-id="companyId"
						:title="question.name"
						:type="question.config.type"
						:disabled="disabled"
						v-model="answers.get(id).file_id"
						ref="fileUpload"
						class="signature-container"
					></QuestionSignatureInput>

					<div
						v-if="question.childQuestions != null &&
        question.childQuestions.length > 0"
					>
						<QuestionFileUpload
							:title="question.childQuestions[0].name"
							:type="question.childQuestions[0].config.type"
							v-model="answers.get(question.childQuestions[0].id).file_id"
							:companyId="companyId"
							:disabled="disabled"
							:multiple="false"
							ref="fileUpload"
						></QuestionFileUpload>
					</div>
					<div class="errors">
						<span v-if="errors.has(question.id)" class="form-error">{{ errors.get(question.id) }}</span>
						<span
							class="child-question-error" v-if="question.childQuestions != null &&
						  question.childQuestions.length > 0 &&errors.has(question.id)"
						>{{ errors.get(question.id) }}
            </span>
					</div>
				</div>

			</div>
			<button
				class="finalSaveButton"
				v-if="showFinalSaveButton"
				type="button"
				:disabled="isLoading || disabled"
				@click="save(true)"
			>
				<SendIcon v-if="!isLoading"/>
				<LoadingIndicator
					v-else style="height: 16px;"
				/>
				Verstuur de controle
			</button>
		</div>
	</ProjectAppointmentDetailSection>
</template>

<script>

import {validateNotRequiredEmail} from "@/common/validators";
import LoadingIndicator from "@/components/LoadingIndicator";
import ProjectAppointmentDetailSection from "@/components/ProjectAppointmentDetailSection";
import QualitySupportTicketSection from "@/components/qualityAppointment/QualitySupportTicketSection.vue";
import QuestionDynamicSelect from "@/components/QuestionDynamicSelect";
import QuestionEmailInput from "@/components/QuestionEmailInput";
import QuestionFileUpload from "@/components/QuestionFileUpload";
import QuestionKmkInput from "@/components/QuestionKmkInput";
import QuestionSignatureInput from "@/components/QuestionSignatureInput";
import QuestionSingleFileUpload from "@/components/QuestionSingleFileUpload";
import {client} from "@/store";
import {CheckIcon, FolderPlusIcon, SendIcon} from "vue-feather-icons";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
	components: {
		QualitySupportTicketSection,
		QuestionDynamicSelect,
		ProjectAppointmentDetailSection,
		FolderPlusIcon,
		SendIcon,
		CheckIcon,
		QuestionFileUpload,
		QuestionSignatureInput,
		QuestionEmailInput,
		QuestionKmkInput,
		QuestionSingleFileUpload,
		LoadingIndicator
	},

	props: {
		questionGroup: Object,
		title: String,
		open: Boolean,
		showNextButton: Boolean,
		showFinalSaveButton: Boolean,
		companyId: Number,
		projectId: Number,
		appointmentId: Number,
		variables: Object,
		disabled: {
			type: Boolean,
			default: false
		},
		isSupportAppointment: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.parseQuestions();
	},

	data() {
		return {
			questions: new Map(),
			answers: new Map(),
			errors: new Map()
		};
	},
	computed: {
		...mapState({
			isLoading: "loading"
		}),
		...mapState('mobile', {
			showKlanttevredenheid: "qualityShowKlanttevredenheid"
		})
	},
	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle",
		}),
		...mapMutations({
			setQualityShowKlanttevredenheid: "mobile/setQualityShowKlanttevredenheid"
		}),
		parseQuestions() {
			const childQuestions = this.questionGroup.questions.filter(question => question.parent_id != null);
			const questions = this.questionGroup.questions.filter(question => question.parent_id == null);
			this.setAnswersForQuestion(questions);
			this.setAnswersForQuestion(childQuestions);
			questions.forEach(question => {
				question.childQuestions = childQuestions.filter(childQuestion => childQuestion.parent_id === question.id)
					.map(childQuestion => {
						childQuestion.config = JSON.parse(childQuestion.config);
						return childQuestion;
					});
				question.config = JSON.parse(question.config);
				this.questions.set(question.id, question);
			});
		},

		setAnswersForQuestion(questions) {
			questions.forEach(question => {
				// for now only support one answer per question
				if (question.answers != null && question.answers.length === 1 && (this.empty(question.answers[0].value) && this.empty(question.answers[0].text_value) && this.empty(question.answers[0].file_id)) === false) {
					if (question.type === "RADIO-KMK") {
						question.answers[0].text_value = JSON.parse(question.answers[0].text_value);
					}
					this.answers.set(question.id, question.answers[0]);
				} else {
					const config = JSON.parse(question.config);
					this.answers.set(question.id, {
						value: config.hasOwnProperty("defaultValue") ? config.defaultValue : null,
						text_value: null,
						file_id: null,
						question_id: question.id,
						question_rev: question.rev
					});
				}
			});
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		},

		validateAnswers() {
			this.errors.clear();
			this.questions.forEach(question => {
				if (question.hasOwnProperty("childQuestions") && question.childQuestions.length > 0) {
					this.validateChildQuestions(question.childQuestions);
				}
				if (question.config.hasOwnProperty("validators")) {
					const answer = this.answers.get(question.id);
					question.config.validators.forEach(validator => {
						switch (validator) {
							case "required":
								if (this.empty(answer.value) && this.empty(answer.text_value) && this.empty(answer.file_id)) {
									this.errors.set(question.id, "Dit veld is verplicht");
								}
								break;
							case "email":
								if (validateNotRequiredEmail(answer.value) === false) {
									this.errors.set(question.id, "Dit is geen geldig e-mailadres");
								}
						}
					});
				}
			});
			this.$forceUpdate();
			return this.errors.size === 0;
		},

		validateChildQuestions(questions) {
			questions.forEach(question => {
				if (question.config.hasOwnProperty("validators")) {
					const answer = this.answers.get(question.id);
					question.config.validators.forEach(validator => {
						switch (validator) {
							case "required":
								if (this.empty(answer.value) && this.empty(answer.text_value) && this.empty(answer.file_id)) {
									this.errors.set(question.id, "Dit veld is verplicht");
								}
								break;
							case "email":
								if (validateNotRequiredEmail(answer.value) === false) {
									this.errors.set(question.id, "Dit is geen geldig e-mailadres");
								}
						}
					});
				}
			});
		},
		shouldShowQuestion(question){
			if(question.config.hasOwnProperty('showWhen') === false){
				return true;
			}
			const dependentQuestion = Array.from(this.questions.values()).find(q => q.constant === question.config.showWhen.constant);
			if(dependentQuestion == null){
				return true;
			}
			const dependentAnswer = this.answers.get(dependentQuestion.id);
			return dependentAnswer.value === question.config.showWhen.value;
		},
		shouldShowNextButton() {
			if(this.questionGroup.constant !== 'QUALITY_SPOUWMUUR_SUPPORT_TICKET') {
				return this.showNextButton;
			}
			const answers = Array.from(this.answers.values());
			return answers.length === 0 || answers[0].value !== "Ja";
		},
		forceChange() {
			setTimeout(() => this.$forceUpdate(), 10)
		},

		save(isFinal) {
			if (this.disabled) {
				this.$emit("open-next");
				return;
			}

			this.setLoading();
			if (this.$refs.fileUpload != null) {
				Promise.all(this.$refs.fileUpload.map(fileUpload => fileUpload.uploadFiles()))
					.catch(error => {
						this.setIdle();
						console.error(error);
						this.$notify({
							group: "app",
							title: "Opslaan mislukt",
							type: "error",
							text: `De bestanden konden niet opgeslagen worden.`
						});
					})
					.finally(() => {
						this.performSave(isFinal);
					});
			} else {
				this.performSave(isFinal);
			}
		},

		performSave(isFinal) {
			if (this.validateAnswers() === false) {
				this.setIdle();
				return;
			}
			let answers = structuredClone(Array.from(this.answers.values()));
			answers = answers.map(answer => {
				if (answer != null && answer.text_value != null && typeof answer.text_value === "object") {
					answer.text_value = JSON.stringify(answer.text_value);
				}
				if (answer != null && answer.value != null && typeof answer.value === "number") {
					answer.value = answer.value.toString();
				}
				return answer;
			});
			client.query(`mutation($projectId: ID!, $answers: [AnswerInput], $finishQuestionnaire: Boolean) {
				updateQualityAnswers(projectId: $projectId, answers: $answers, finishQuestionnaire: $finishQuestionnaire)
			}`, {
				projectId: this.projectId,
				answers: answers,
				finishQuestionnaire: isFinal
			}).then(result => {
				if (result.updateQualityAnswers === true) {
					this.$notify({
						group: "app",
						title: "Opslaan gelukt",
						type: "success",
						text: `De antwoorden zijn succesvol opgeslagen`
					});
					this.setIdle();
					this.$emit("open-next");

					if (isFinal === true) {
						if (this.isSupportAppointment) {
							this.$notify({
								group: "app",
								title: "Afgerond",
								type: "success",
								text: `De controle is succesvol afgerond`
							});
						}

						this.$router.push("/kwaliteit-afspraken");
					}
				}
			}).catch(error => {
				this.$notify({
					group: "app",
					title: "Opslaan mislukt",
					type: "error",
					text: `Er is een fout opgetreden bij het opslaan van de antwoorden`
				});
				this.setIdle();
			});
		}
	}
};
</script>
<style lang="scss" scoped>

.question {
	width: 100%;
	min-width: 100%;

	&.stacked {
		width: 50%;
		min-width: 50%;

		&:only-child {
			width: 100%;
			min-width: 100%;
		}

		.stacked-inner {
			margin: 8px;

			input {
				margin-top: 8px;
				width: 100%;
			}
		}
	}

	.question-inner {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 24px;

		&.vertical {
			flex-direction: column;
			align-items: flex-start;
		}
	}

	label {
		font-size: 1.2rem;
		font-weight: 500;
		min-width: 200px;
		max-width: 60%;
	}

	input, select {
		border: 2px solid #ced6dd;
		padding: 6px;
		border-radius: 5px;
		height: 36px;
		box-sizing: border-box;
		width: 30%;
		background: #ffffff;
		min-width: 16px;

		&.no-label {
			width: 100%;
		}

		&[type=email] {
			width: 60%;
		}

		&[type=radio] {
			width: 24px;
		}
	}

	textarea {
		border: 2px solid #ced6dd;
		padding: 6px;
		border-radius: 5px;
		box-sizing: border-box;
		width: 100%;
		background: #ffffff;
	}

	button {
		height: 36px;
		border: 2px solid #35a5a4;
		border-radius: 5px;
		color: #35a5a4;
		background: #ffffff;
		align-items: center;
		display: flex;
		min-width: 130px;
		justify-content: center;
		gap: 8px;
	}

	.radio-options {
		//min-width: 50%;
		display: flex;
		justify-content: flex-end;

		&.vertical {
			flex-direction: column;
		}

		.option {
			display: flex;
			align-items: center;

			label {
				min-width: unset;
				white-space: nowrap;
				padding: 8px 16px 8px 8px;
				font-weight: normal;
			}
		}
	}
}

.question-section {
	display: flex;
	overflow: hidden;
	flex-wrap: wrap;
}

.errors {
	color: red;
	width: 100%;
	display: flex;
	justify-content: space-between
}

.finalSaveButton {
	height: 36px;
	border: 2px solid #35a5a4;
	border-radius: 5px;
	background: #35a5a4;
	color: #ffffff;
	font-weight: 500;
	align-items: center;
	display: flex;
	min-width: 130px;
	justify-content: center;
	gap: 8px;
	width: 100%;
	margin-top: 16px;
}

.finalSaveButton[disabled] {
	opacity: 0.5;
}
</style>
